import Vue from 'vue'

import Qs from 'qs'

class ItemMutations {
  async indexItem({itemId, params}) {
    return await Vue.axios
      .get('app/item-mutations-by-item/' + itemId, {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async read({id}) {
    return await Vue.axios
      .get('app/item-mutations/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/item-mutations/' + id, data)
  }
}

const itemMutations = new ItemMutations()

export default itemMutations
